/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

export interface AuthModel {
  token(token: any): { data: any } | PromiseLike<{ data: any }>;
  api_token: string;
  uuid?: string;
  chefId?: string;
  name?: string;
  profile?: any;
  password: string | undefined;
  email?: string;
  currentlyAvailableStatus?: boolean;
  refreshToken?: string;
}

export interface UserModel {
  data: {
    uuid?: string;
    chefId?: string;
    name: string;
    profile: any;
    password: string | undefined;
    email: string;
    api_token: any;
    currentlyAvailableStatus: boolean;
  };
  address: any;
  id?: number;
  chefId?: number;
  profileStatus?: any;
  primaryID?: string;
  uuid: string;
  token: string;
  api_token: string;
  role: string;
  username: string;
  profile: string;
  password: string | undefined;
  email: string;
  currentlyAvailableStatus: boolean;
  phone?: string;
  roles?: Array<number>;
  pic?: string;
  language?: "en" | "de" | "es" | "fr" | "ja" | "zh" | "ru";
  timeZone?: string;
  auth?: AuthModel;
  name: string;
}

export type ChefRegister = {
  id?: undefined | null | number | string;
  primaryId?: string;
  name: string;
  mobileNumber: string;
  mobileNumber1: string;
  otpValue: string;
  email: string;
  password: string;
  city: string;
  state: string;
  country: string;
  longitude: string;
  latitude: string;
  timeZone: string;
  address: string;
  zipCode: string;
  formImage: any;
  status: string;
  message: string;
  otpDevice: string;
  token: string;
  providerUid: string;
  providerId: string;
  signupType?: number;
};


export const initialValuesChefRegister: ChefRegister = {
  name: "",
  mobileNumber: "",

  otpValue: "",
  email: "",
  password: "",
  city: "",
  state: "",
  mobileNumber1: "",
  country: "",
  zipCode: "",
  address: "",
  longitude: "",
  latitude: "",
  timeZone: "",
  formImage: "",
  status: "",
  message: "",
  otpDevice: "",
  token: "",
  providerId: "",
  providerUid: "",
};

export type ChefProfile = {
  id?: undefined | null | number | string;
  primaryId?: string;
  name: string;
  mobileNumber: string;
  mobileNumber1: string;
  phoneNumber: string;
  phoneNumber1: string;
  email: string;
  brandName: string;
  location: string;
  chefProfile: string;
  notificationSound: string;
  approvalStatus: any;
  enableDisableStatus: any;
  address: any;
  city: string;
  state: string;
  country: string;
  longitude: string;
  latitude: string;
  timeZone: string;
  zipCode: string;
  status: string;

  profile: any;
  password: any;
};

export type ChefBasicProfile = {
  id?: undefined | null | number | string;
  primaryId?: string;
  password: string;
  newpassword: string;
  confirmpassword: string;
  currentpassword: string;
  chefProfile: any;
  approxDeliveryTime: any;
};
